<template>
  <b-form @submit="signIn" class="sing-in-form">
    <h1 class="sign-in-title">Sign In</h1>

    <b-form-group :state="emailState">
      <label class="form__label input-label" for="email-input">Email</label>
      <b-form-input
        id="email-input"
        v-model="$v.email.$model"
        class="sing-up-input"
        placeholder="Enter email"
        autocomplete="username"
        :state="emailState"
      />
      <template #invalid-feedback>
        <div v-if="!$v.email.required">{{VALIDATION_MESSAGES.common.required}}</div>
        <div v-else-if="!$v.email.email">{{VALIDATION_MESSAGES.email.invalid}}</div>
        <div v-else v-for="(error, index) in emailServerErrors" :key="index">
          {{ error }}
        </div>
      </template>
    </b-form-group>

    <PasswordField
      v-model="$v.password.$model"
      id="password-input"
      label="Password"
      placeholder="Enter password"
      autocomplete="current-password"
      :state="passwordState"
    >
      <template #invalid-feedback>
        <div v-if="!$v.password.required">{{VALIDATION_MESSAGES.common.required}}</div>
        <div v-else v-for="(error, index) in passwordServerErrors" :key="index">
          {{ error }}
        </div>
      </template>
    </PasswordField>

    <div class="d-flex justify-content-center w-100">
      <router-link
        v-if="!ReSignIn"
        class="forgot-link link"
        :to="{ name: ROUTES.PASSWORD_RESET.name }"
      >
        Forgot password?
        <span class="forget-border"></span>
      </router-link>
    </div>

    <b-button class="button" type="submit" variant="primary" :disabled="submitRequestPending">
      Sign In
    </b-button>

    <div class="sign-with">
      <span class="text">Or sign in with</span>
    </div>

    <div class="text-center">
      <router-link class="atlassian" to="" @click.native="logInToJira">
        <img  :style="{height: '26px', width: 'auto', objectFit: 'contain'}" src="/images/atlassian.webp" alt="jira logo" />
      </router-link>
    </div>
  </b-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import PasswordField from '@components/sign-up/PasswordField.vue'

export default {
  name: 'SignInForm',
  mixins: [validationMixin],
  components: { PasswordField },
  props: {
    ReSignIn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      email: '',
      password: '',
      status: 'accepted',

      emailServerErrors: null,
      passwordServerErrors: null,

      submitButtonPressed: false,
      submitRequestPending: false
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  computed: {
    emailState () {
      return this.submitButtonPressed && (this.emailServerErrors || this.$v.email.$invalid) ? false : null
    },
    passwordState () {
      return this.submitButtonPressed && (this.passwordServerErrors || this.$v.password.$invalid) ? false : null
    }
  },
  methods: {
    signIn (e) {
      e.preventDefault()

      this.submitButtonPressed = true

      this.emailServerErrors = null
      this.passwordServerErrors = null

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.submitRequestPending = true

      this.axios
        .post('/api/auth/login', {
          email: this.email,
          password: this.password
        })
        .then(async (response) => {
          const user = response.data.user.original
          await this.authUserAtFrontEnd(response.data.access_token, response.data.refresh_token, user, user.user_roles)
        })
        .catch((error) => {
          if (error.response?.data?.errors) {
            const { email, password, forwardTo, ...restErrors } = error.response.data.errors

            if (email) this.emailServerErrors = email
            if (password) this.passwordServerErrors = password

            if (forwardTo) {
              this.$router.push(forwardTo)
            }

            const errors = Object.values(restErrors)

            for (let i = 0; i < errors.length; i++) {
              this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
            }
          } else {
            this.$snotify.error(error.response?.data?.error ?? error, 'Error', this.$store.state.snotify)
          }
        })
        .finally(() => {
          this.submitRequestPending = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.forgot-link {
  position: relative;
  border-bottom: 0;
  font-size: 18px;

  .forget-border {
    border-top: 0.5px solid $fontColorAccent;
    display: block;
    width: 100%;
    position: absolute;
    bottom: 5px;
  }
}
</style>
